<script setup lang="ts">
import TableHeader from "@/components/Every24HoursReportPreviewParts/TableHeader.vue";
import TableRow from "@/components/Every24HoursReportPreviewParts/TableRow.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import {
  TITLE_HEADERS,
  DRIVING_DETAIL_HEADERS,
  DRIVING_DETAIL_ROWS
} from "@/services/consts/every_24_hours_report";

const props = defineProps<{
  deliveryPlan: every24HoursPreviewType
  index: number
}>();

</script>
<template>
  <v-table
    class="mx-auto col-12"
    style="width: 85%"
    density="compact"
  >
    <TableHeader
      :headers="TITLE_HEADERS"
      :deliveryPlan="props.deliveryPlan"
    />
  </v-table>
  <v-table
    class="mx-auto col-12"
    style="width: 85%"
    density="compact"
  >
    <TableHeader
      :headers="DRIVING_DETAIL_HEADERS"
    />
    <TableRow
      :deliveryPlan="props.deliveryPlan"
      :index="props.index"
      :rowItems="DRIVING_DETAIL_ROWS"
    />
  </v-table>
</template>
